<template>
  <v-dialog v-model="dialog" scrollable max-width="500">
    <v-card>
      <v-card-title>
        等級編集
        <v-spacer />
        <IconButton icon="mdi-close" @click="cancel" />
      </v-card-title>

      <v-card-text>
        <v-form ref="grade_form">
          <v-container>
            <v-row>
              <v-col cols="6">
                <FormInputComponent
                  label="表示順"
                  type="number"
                  v-model="showOrder"
                  rules="required"
                  :counter="4"
                />
              </v-col>
              <v-col cols="12">
                <FormInputComponent
                  label="等級名称"
                  type="string"
                  v-model="gradeName"
                  rules="required"
                  :counter="20"
                />
              </v-col>
              <v-col cols="12">
                <v-select
                  label="ユーザランク"
                  v-model="userRank"
                  item-text="label"
                  item-value="value"
                  :items="userRankLabels"
                  return-object
                  outlined
                />
              </v-col>
              <v-col cols="12">
                <v-select
                  label="使用状態"
                  v-model="expiration"
                  item-text="label"
                  item-value="value"
                  :items="isActiveLabels"
                  return-object
                  outlined
                />
              </v-col>
            </v-row>
            <v-row v-if="loading"
              ><v-col><Loader :loading="loading" /></v-col
            ></v-row>
            <v-row>
              <v-col>
                <Button @click="erntry_confirm" color="primary">登録</Button>
              </v-col>
              <v-col v-if="!entryFlg">
                <Button @click="delete_confirm" color="danger">削除</Button>
              </v-col>
            </v-row>
          </v-container>
        </v-form>

        <ConfirmDialog
          ref="confirm"
          title="等級情報編集"
          :message="confirmMessage"
          buttonMessage="OK"
          @confirm="editGradeInfo"
        >
        </ConfirmDialog>

        <DialogMessage ref="dialog" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import config from '../../../const.js';
import message from '../../../message.js';
import moment from 'moment';
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';
import { getSessionStorageItem } from '../../../common.js';
export default {
  components: {
    ConfirmDialog,
  },
  data: () => ({
    loading: false,
    dialog: false,
    confirm: false,
    entryFlg: false,
    confirmMessage: null,
    deleteFlg: false,
    resolve: null,
    reject: null,

    gradeId: null,
    organaizationKey: null,
    gradeName: null,
    showOrder: 0,
    createdAt: null,
    updateAt: null,

    userRank: { label: '', value: '' },
    expiration: { label: '', value: '' },

    userRankLabels: [],

    isActiveLabels: [
      { label: config.USE_IN_NAME, value: config.USE_IN },
      { label: config.USE_STOP_NAME, value: config.USE_STOP },
    ],
  }),

  methods: {
    open(item) {
      this.dialog = true;

      // ユーザランク情報の設定
      this.get_userRank();

      // セレクトボックス初期化
      this.userRank = { label: '', value: '' };
      this.expiration = { label: '', value: '' };

      // 等級設定
      if (item == null) {
        this.entryFlg = true;
        this.gradeId = null;
        this.organaizationKey = null;
        this.gradeName = null;
        this.userRank = { label: '', value: '' };
        this.expiration = { label: '', value: '' };
        this.showOrder = null;
        this.createdAt = null;
        this.updateAt = null;
      } else {
        this.entryFlg = false;
        this.gradeId = item.GRADE_ID;
        this.organaizationKey = item.ORGANIZATION_KEY;
        this.gradeName = item.GRADE_NAME;
        this.userRank.value = item.USER_RANK;
        this.expiration.value = item.EXPIRATION;
        this.showOrder = item.SHOW_ORDER;
        this.createdAt = item.CREATED_AT;
        this.updateAt = item.UPDATED_AT;
      }

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    get_userRank() {
      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      // ローディング画像表示
      this.loading = true;

      // TOP
      var itemTop = {
        label: userInfo.USER_RANK_NAME_1,
        value: config.USER_RANK_TOP,
      };
      this.userRankLabels.push(itemTop);
      // M
      var itemM = {
        label: userInfo.USER_RANK_NAME_2,
        value: config.USER_RANK_M,
      };
      this.userRankLabels.push(itemM);
      // S
      var itemS = {
        label: userInfo.USER_RANK_NAME_3,
        value: config.USER_RANK_S,
      };
      this.userRankLabels.push(itemS);
      // J
      var itemJ = {
        label: userInfo.USER_RANK_NAME_4,
        value: config.USER_RANK_J,
      };
      this.userRankLabels.push(itemJ);
      // E
      var itemE = {
        label: userInfo.USER_RANK_NAME_5,
        value: config.USER_RANK_E,
      };
      this.userRankLabels.push(itemE);

      // ローディング画像終了
      this.loading = false;
    },
    erntry_confirm() {
      // 入力チェック
      if (!this.$refs.grade_form.validate()) {
        return;
      }
      // ユーザランクチェック
      if (this.userRank.value == null || !this.userRank.value) {
        this.$refs.dialog.open(
          'info',
          'ユーザランクが選択されていません。ユーザランクを選択して下さい。'
        );
        return;
      }
      // 使用状態チェック
      if (this.expiration.value == null || !this.expiration.value) {
        this.$refs.dialog.open(
          'info',
          '使用状態が選択されていません。使用状態を選択して下さい。'
        );
        return;
      }
      // 等級名称存在チェック
      this.checkGradeExists();
    },
    checkGradeExists() {
      // ローディング画像表示
      this.loading = true;

      let userInfo = getSessionStorageItem();
      axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/grade/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // ユーザ等級データ取得
          this.loading = false;

          let useGrade = false;
          for (let i = 0; i < response.data.length; i++) {
            if (this.gradeName == response.data[i].GRADE_NAME) {
              useGrade = true;
              break;
            }
          }
          if (useGrade) {
            let msgStr =
              '[' +
              this.gradeName +
              ']の等級情報は、既に存在するため登録できません。';
            this.$refs.dialog.open('info', msgStr);
            return;
          } else {
            // 確認ダイアログ表示
            this.deleteFlg = false;
            this.confirmMessage =
              '[' + this.gradeName + ']の等級情報を登録しますか？';
            this.$refs.confirm.open();
          }
        })
        .catch((error) => {
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
          return;
        });
    },
    async delete_confirm() {
      // 入力チェック
      if (!this.$refs.grade_form.validate()) {
        // チェックエラー
        return;
      }

      // ローディング画像表示
      this.loading = true;

      let userInfo = getSessionStorageItem();
      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/organization/usergrade/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY +
            '/' +
            this.gradeId
        )
        .then((response) => {
          // ユーザ等級データ取得
          this.loading = false;

          let hasGrade = false;
          for (let i = 0; i < response.data.length; i++) {
            hasGrade = true;
            break;
          }
          if (hasGrade) {
            let msgStr =
              '[' +
              this.gradeName +
              ']の等級情報は、既に使用されているため削除できません。';
            this.$refs.dialog.open('info', msgStr);
            return;
          } else {
            // 確認ダイアログ表示
            this.deleteFlg = true;
            this.confirmMessage =
              '[' + this.gradeName + ']の等級情報を削除しますか？';
            this.$refs.confirm.open();
          }
        })
        .catch((error) => {
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
          return;
        });
    },
    editGradeInfo() {
      // セッションチェック
      let userInfo = getSessionStorageItem();
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }
      if (this.deleteFlg) {
        // 削除処理
        this.deleteGradeInfoRequest();
      } else {
        // 登録処理
        this.editGradeInfoRequest();
      }
    },
    editGradeInfoRequest() {
      // ローディング画像表示
      this.loading = true;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      // ユーザ情報作成
      if (this.entryFlg) {
        // 新規登録
        this.gradeId =
          userInfo.ORGANIZATION_KEY + moment().format('YYYYMMDDHHmmss');
        this.createdAt = moment().format('YYYYMMDDHHmmss');
      }

      // 共通
      this.updateAt = moment().format('YYYYMMDDHHmmss');

      //----- 等級情報登録リクエストPOST
      axios
        .post(
          config.CONNECT_EVALUATIONS_URL + '/Evaluations/manages/grade/entry',
          {
            SESSION_ID: userInfo.SESSION_ID,
            SESSION_USER_ID: userInfo.USER_ID,

            GRADE_ID: this.gradeId,
            ORGANIZATION_KEY: userInfo.ORGANIZATION_KEY,
            GRADE_NAME: this.gradeName,
            USER_RANK: this.userRank.value,
            SHOW_ORDER: this.showOrder,
            EXPIRATION: this.expiration.value,
            CREATED_AT: this.createdAt,
            UPDATED_AT: this.updateAt,
          }
        )
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr = message.MSG_INFO_GRADE_ENTRY_COMPLETE;
            this.$refs.dialog.open('info', msgStr);
            this.$emit('edit');
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.resolve(true);
      this.dialog = false;
    },
    deleteGradeInfoRequest() {
      // ローディング画像表示
      this.loading = false;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      // 新規登録モードの場合は処理終了
      if (this.entryFlg) {
        return;
      }

      //----- 等級情報削除リクエストPOST
      axios
        .post(
          config.CONNECT_EVALUATIONS_URL + '/Evaluations/manages/grade/delete',
          {
            SESSION_ID: userInfo.SESSION_ID,
            SESSION_USER_ID: userInfo.USER_ID,
            GRADE_ID: this.gradeId,
          }
        )
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr = this.gradeName + message.MSG_INFO_GRADE_DELETE_COMPLETE;
            this.$refs.dialog.open('info', msgStr);
            this.$emit('edit');
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.resolve(true);
      this.dialog = false;
    },

    cancel() {
      this.dialog = false;
    },

    async regist() {
      this.dialog = false;
    },
  },
};
</script>
